









































import {Vue, Component} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import editor from '@/components/common/summernote/Index.vue';
import {HistoryItem} from '@/types/terms';
import {toI18n} from '@/utils/commonUtils';
import {popupResize} from '@/utils/ncp';

@Component({
  components: {
    PageFormSelect,
    editor
  }
})
export default class OpenedPopupExample extends Vue {
  private editorData = '';
  private selectData: HistoryItem[] = [
    {
      termsNo: -1,
      enforcementDateTime: this.toI18n('TERMS_HISTORYPOP_NO_SAVED_CONTENT'),
      contents: ''
    }
  ];

  private tabNameText = {
    access: {
      title: this.toI18n('TERMS_HISTORYPOP_ACCESS_TITLE'),
      notice: this.toI18n('TERMS_HISTORYPOP_ACCESS_NOTICE'),
      note: this.toI18n('TERMS_HISTORYPOP_ACCESS_NOTE')
    },
    'e-commerce': {
      title: this.toI18n('TERMS_HISTORYPOP_ECOMMERCE_TITLE'),
      notice: this.toI18n('TERMS_HISTORYPOP_ECOMMERCE_NOTICE'),
      note: this.toI18n('TERMS_HISTORYPOP_ECOMMERCE_NOTE')
    },
    'personal-info': {
      title: this.toI18n('TERMS_HISTORYPOP_PERSONALINFO_TITLE'),
      notice: this.toI18n('TERMS_HISTORYPOP_PERSONALINFO_NOTICE'),
      note: this.toI18n('TERMS_HISTORYPOP_PERSONALINFO_NOTE')
    },
    'recurring-payment': {
      title: this.toI18n('TERMS_HISTORYPOP_RECURRING_PAYMENT_TITLE'),
      notice: this.toI18n('TERMS_HISTORYPOP_RECURRING_PAYMENT_NOTICE'),
      note: this.toI18n('TERMS_HISTORYPOP_RECURRING_PAYMENT_NOTE')
    },
    'auto-approval': {
      title: this.toI18n('TERMS_HISTORYPOP_AUTO_APPROVAL_TITLE'),
      notice: this.toI18n('TERMS_HISTORYPOP_AUTO_APPROVAL_NOTICE'),
      note: this.toI18n('TERMS_HISTORYPOP_AUTO_APPROVAL_NOTE')
    }
  };

  private close(): void {
    window.close();
  }
  private editorContent: {noticeContent: string; searchContent: string} = {
    noticeContent: '',
    searchContent: ''
  };

  private editorOnChange({html, text}: {html: string; text: string}): void {
    Object.assign(this.editorContent, {noticeContent: html, searchContent: text});
  }

  private changeEditContent(event: any) {
    this.editorData = (
      this.selectData.find((item: HistoryItem): any => {
        return item.termsNo.toString() === event.target.value;
      }) || {termsNo: -1, enforcementDateTime: '', contents: ''}
    ).contents;
  }

  private toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  private yearMonthDate: string[] = [this.toI18n('TERMS_HISTORYPOP_YEAR') + ' ', this.toI18n('TERMS_HISTORYPOP_MONTH') + ' ', this.toI18n('TERMS_HISTORYPOP_DATE')];
  private tempObj: {} = {};
  private handleArray(selectData: HistoryItem[]): HistoryItem[] {
    const tempArray = selectData.map(
      (item: HistoryItem): HistoryItem => {
        const termsNo = item.termsNo;
        const dateTimeArray = item.enforcementDateTime.substring(0, 10).split('-');
        const enforcementDateTime = dateTimeArray
          .map((item: string, idx: number) => {
            return item + this.yearMonthDate[idx];
          })
          .join('');
        const contents = item.contents;
        return {termsNo, enforcementDateTime, contents};
      }
    );

    [...tempArray].forEach((item: HistoryItem) => {
      const sameItems = tempArray.filter((history: HistoryItem) => history.enforcementDateTime === item.enforcementDateTime);
      if (sameItems.length > 1) {
        sameItems.forEach((sameItem: HistoryItem, idx: number) => {
          for (let i = 0, len = tempArray.length; i < len; i++) {
            if (sameItem.termsNo === tempArray[i].termsNo) {
              tempArray[i].enforcementDateTime += `(${sameItems.length - idx})`;
            }
          }
        });
      }
    });

    return tempArray;
  }

  private created() {
    const tabName = this.$route.params.tabName;
    let termsType = '';
    switch (tabName) {
      case 'access':
        termsType = 'USE';
        break;
      case 'e-commerce':
        termsType = 'E_COMMERCE';
        break;
      case 'personal-info':
        termsType = 'PI_PROCESS';
        break;
      case 'recurring-payment':
        termsType = 'REGULAR_PAYMENT_USE';
        break;
      case 'auto-approval':
        termsType = 'AUTO_APPROVAL_USE';
        break;
    }
    const mallNo = Number(this.$route.query.mallNo);
    const params:any = {
      termsType,
      mallNo
    };
    
    this.$api.getTermsHistories({params}).then(({ data }) => {
      if (data.contents.length) {
        this.selectData = this.handleArray(data.contents as HistoryItem[]);
        this.editorData = this.selectData[0].contents;
      }
    });
  }

  private mounted() {
    this.$nextTick(() => {
      popupResize(960);
    });
  }
}
